module.exports = __webpack_public_path__ + "static/img/service.522bc3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service.png
// module id = ok8X
// module chunks = 22